<template>
  <VCard class="item">
    <RouterLink
      class="item-link"
      :to="{ name: 'candidate',
             params: { id: candidate.vacancy.id, candidateId: candidate.id } }"
    >
      <VChip
        v-if="candidate.isNew"
        color="#1FC57F"
        dark
        class="new-badge"
      >
        {{ $t('new') }}
      </VChip>
      <div>
        <v-avatar size="64">
          <img
            v-if="photo && photo.url"
            :src="photo.url"
            alt=""
            class="candidate-image"
          >
        </v-avatar>
        <VCardTitle class="candidate-title">
            {{ candidate.firstName }} {{ candidate.lastName }}
        </VCardTitle>
        <VCardSubtitle class="candidate-subtitle">
          <RouterLink
            class="candidate-subtitle-link"
            :to="{ name: 'vacancy', params: { id: candidate.vacancy.id } }"
          >
            {{ candidate.vacancy.title }}
          </RouterLink>
        </VCardSubtitle>
        <VCardSubtitle class="candidate-date">
          {{ date }}
        </VCardSubtitle>
      </div>
    </RouterLink>
  </VCard>
</template>

<script>
import { candidatePhotoType } from '@/enums';

const moment = require('moment');

export default {
  name: 'CandidateBigSliderItem',
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    photoType: {
      type: String,
      default: candidatePhotoType.W300,
    },
  },
  computed: {
    photo() {
      return this.candidate.photos.find((p) => p.type === this.photoType);
    },
    date() {
      const diffDays = moment().diff(this.candidate.interviewedAt, 'days');
      const dateObj = moment(this.candidate.interviewedAt)
        .locale(this.$i18n.locale.toLowerCase());
      if (diffDays < 1) {
        return dateObj.fromNow();
      }
      return dateObj.format('LL');
    },
  },
};
</script>

<style lang="scss" scoped>
  .item {
    width: 16.5rem;
    position: relative;
    text-align: center;
    border-radius: 0.625rem;
    margin-right: 1.25rem;
    &.v-card {
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
    }
    &:last-child {
      margin-right: 0.625rem;
    }
  }
  .item-link {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    padding: 1.25rem 1.25rem 0.9375rem 1.25rem;
  }
  .new-badge.v-chip {
    position: absolute;
    height: 20px;
    padding: 2px 8px;
    z-index: 1;
    background-color: #1FC57F;
    top: 4px;
    right: 4px;
    font-size: 0.75rem;
    line-height: 1;
    border-radius: 8px;
    text-align: center;
  }
  .v-avatar .candidate-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  .candidate-title.v-card__title {
    display: block;
    font-size: 1rem !important;
    line-height: 1.25;
    text-align: center;
    max-width: 226px;
    padding: 9px 16px 8px;
    margin: 0 auto;
  }
  .candidate-subtitle.v-card__subtitle {
    font-size: 0.75rem;
    line-height: 1.17;
    max-width: 226px;
    margin: 0 auto;
  }
  .candidate-title, .candidate-subtitle-link {
    color: #212121;
    text-decoration: none;
  }
  .candidate-date {
    font-size: 0.75rem;
    line-height: 1.67;
    color: #757575;
    padding: 14px 16px 0;
  }
</style>

<i18n locale="en" lang="yaml">
  new: new
</i18n>

<i18n locale="ru" lang="yaml">
  new: новое
</i18n>
